//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 按需引入部分组件
import { RQ } from 'utils';
import * as F from 'utils/F';

import { dateFormat } from 'utils/filters';
import { yoButton } from 'components';
import List from 'components/list/index';

import action from './action';
import { Button, Tab, Tabs, Cell, CellGroup } from 'vant';

var userAgent = navigator.userAgent;
var phoneType = userAgent.indexOf('iPhone') > -1 ? 'iPhone' : 'android';
var isWeChat = userAgent.indexOf('MicroMessenger') > -1;
export default {
  name: 'coupon',
  props: ['params'],
  metaInfo: {
    title: '领券中心'
  },
  created() {
    this.getMemberInfo();
    if (this.isWeChat) {
      this.confirmButtonText = '立即开通';
    } else {
      this.confirmButtonText = '下载APP';
    }
  },
  data() {
    return {
      cdn: G.cdn,
      showMn: false,
      confirmButtonText: '',
      tabs: ['', ''], //nav列表
      activeTab: 0,
      popupVisible1: false,
      inviteCode: this.params.inviteCode || '',
      enterprise: this.params.enterprise || '',
      isWeChat: isWeChat,//微信
      phoneType: phoneType,
      list: {
        items: [],
        page: 1
      },
      list1: {
        items: [],
        page: 1
      },
      MemberInfo: {}
    };
  },
  computed: {},
  filters: {
    dateFormat
  },
  components: {
    /*vux*/
    /*diy*/
    yoButton,
    'van-button': Button,
    'van-tabs': Tabs,
    'van-tab': Tab,
    //    'van-list': List,
    'ylp-list': List,
    CellGroup,
    'van-cell': Cell
  },
  methods: {
    ...action
  }
};



// WEBPACK FOOTER //
// ./src/module/coupon/page.vue